'use client'

import Link from 'next/link'

import { ContactForm } from '@/components/ContactForm'
import { SectionHeader } from '@/components/SectionHeader'

export default function Page() {
  return (
    <>
      <section className="mb-12 md:mb-20">
        <SectionHeader title="Contact" subtitle="お問い合わせ">
          <p>
            法人・個人問わず、一貫したサポートを提供しています。
            <br />
            確定申告から法人税務、経営に関するお悩みなど、まずはお気軽にご相談ください。
          </p>
          <p className="text-sm leading-normal text-body-65">
            ※「個人情報保護方針」については
            <Link
              href="/policy"
              className="text-primary underline underline-offset-2 hover:no-underline"
            >
              こちら
            </Link>
            をご確認ください。
          </p>
        </SectionHeader>
        <div className="px-lg">
          <ContactForm />
        </div>
      </section>
    </>
  )
}
